import type { ClarityFunction } from './clarity.d';

const PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID?.trim();

let initialized = false;

function injectClarityScript(projectId: string): void {
  if (window.clarity) return;

  const clarity = function (...args: unknown[]) {
    (clarity.q = clarity.q || []).push(args);
  } as unknown as ClarityFunction;

  window.clarity = clarity;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
  document.head.appendChild(script);
}

export function initClarity(): void {
  if (!PROJECT_ID || initialized) return;

  injectClarityScript(PROJECT_ID);
  window.clarity?.('consent');
  initialized = true;
}

export function identifyClarityUser(customerId: number | string): void {
  if (!PROJECT_ID || !initialized || !window.clarity) return;

  window.clarity('identify', String(customerId));
}
